import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';

configure({ enforceActions: 'always' });

class ProductComboStore extends StoreModel {
    constructor() {
        super('productCombo', {
            namePlural: 'productCombos',
            sort: 'sort',
            api: {
                search: {
                    url: '/api/productcombo/',
                    params: {},
                },
                load: {
                    url: '/api/productcombo/',
                    params: {},
                },
                save: {
                    url: '/api/productcombo/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable productCombo = {};

    @observable productCombos = [];

}

const store = new ProductComboStore();
export default store;



// WEBPACK FOOTER //
// ./stores/productcombo.js